import { render, staticRenderFns } from "./CarHealthIssueItems.vue?vue&type=template&id=6fa21a47&"
import script from "./CarHealthIssueItems.vue?vue&type=script&lang=ts&"
export * from "./CarHealthIssueItems.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports